// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm_form__2D1t6","button":"ContactForm_button__l8v5g"};